
import Actions from '../actions';
import React from 'react';
import {Helmet} from 'react-helmet';
import {Link} from 'react-router-dom';
import Store from './store';


class LogoutPage extends React.Component {
  constructor(props) {

    super(props);

    this.input = {};
    this.state = Store.getState();
  }

  componentDidMount() {

    this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

    Actions.logout();
  }

  componentWillUnmount() {

    this.unsubscribeStore();

    Actions.resetStore();
  }

  onStoreChange() {

    this.setState(Store.getState());
  }

  render() {

    const alerts = [];

    if (this.state.success) {
      alerts.push(
        <div key="success" className="alert alert-success">
          Logout successful.
        </div>
      );
    }
    else if (this.state.validation.error) {
      alerts.push(
        <div key="danger" className="alert alert-warning">
          {this.state.validation.error}
        </div>
      );
    }

    return (
      <section className="container">
        <Helmet>
          <title>Sign out</title>
        </Helmet>
        <div className="container">
          <div className="logout-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
            <h1 className="display-4">Logged Out</h1>
          </div>
          <div className="row">
            <div className="col-12">
              {alerts}
              <Link to="/login" className="btn btn-link">
                Log in again
              </Link>
            </div>
          </div>
          <div className="row auth-form-tip">
            <p className="text-center">Don’t have an account? <Link to="/signup">Get an API Key now.</Link></p>
          </div>
        </div>
      </section>
    );
  }
}


export default LogoutPage;



// WEBPACK FOOTER //
// ./client/pages/main/login/logout/index.jsx